module.exports = __webpack_public_path__ + "static/media/20039132_l.9583d6a2.png";